import React from 'react';
import PropTypes from 'prop-types';
import IconWithText from '../Icons/IconWithText';
import Button from '../Buttons/Button';
import DropdownSection from '../Dropdowns/DropdownSection';

const SocialShare = ({ onClick, shareCount }) => {
  let facebookCount = '';
  // if (shareCount.facebook !== 0) {
  //   facebookCount = shareCount.facebook;
  // }

  let twitterCount = '';
  // if (shareCount.twitter !== 0) {
  //   twitterCount = shareCount.twitter;
  // }

  return (
    <div>
      <DropdownSection><div className="dropdown-item"><h2 className="dropdown-heading">Share this</h2></div></DropdownSection>
      <DropdownSection>
        <div className="dropdown-item">
          <ul className="inline-list-spaced">
            <li><Button onClick={() => onClick('facebook')} classes="color facebook"><IconWithText name="facebook" size="s" fill="white">{`Facebook ${facebookCount}`}</IconWithText></Button></li>
            <li><Button onClick={() => onClick('twitter')} classes="color twitter"><IconWithText name="twitter" size="s" fill="white">{`Twitter ${twitterCount}`}</IconWithText></Button></li>
            <li><Button onClick={() => { navigator.clipboard.writeText(window.location.href); }} classes="color btn"><IconWithText name="copy" size="s" fill="white">Copy Link</IconWithText></Button> </li>
          </ul>
        </div>
      </DropdownSection>
    </div>
  );
};

SocialShare.propTypes = {
  onClick: PropTypes.func,
  shareCount: PropTypes.object,
};

export default SocialShare;



// WEBPACK FOOTER //
// ./library/app/components/Global/Sharing/SocialShare.js